styleBreadCrumbs = function () {
    let element = document.getElementById('bread-crumbs-ol')
    if(element){
        let i=0;
        let innerElements = element.children;
        let loopLimit = innerElements.length;
        for(;i<loopLimit;i++){
            if(innerElements[i].classList.contains('text-primary')){
                break;
            }
        }
        if(i>0){
            let j=i-1;
            while(j>=0){
                innerElements[j].classList.add('boldness')
                j--;
            }
        }
        innerElements[i].children[0].removeAttribute("href")
        i++
        for(;i<loopLimit;i++){
            innerElements[i].classList.add('text-muted')
            innerElements[i].children[0].removeAttribute("href")
        }
    }
}
